import { Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TitleService } from './core/services/title/title.service';
import { RoutesKeys } from './utils/routes';

@Injectable()
/**
 * Page Title Strategy sets page titles depending on current url
 */
export class PageTitleStrategy extends TitleStrategy {
  readonly defaultPageTitle = 'epson-loyalty-and-rewards';
  readonly oopsPageTitle = 'oops';
  /**
   * @constructor
   */
  constructor(private readonly titleService: TitleService) {
    super();
  }

  /**
   * Builds a title from a given URL
   * @param {RouterStateSnapshot} routerState
   * @return {string}
   */
  override buildTitle(routerState: RouterStateSnapshot): string {
    const urlParts = routerState.url.split('/').filter((s) => s);

    const titleKey = urlParts[0]?.replace(/\?.*/g, '');
    if (!titleKey) {
      return this.defaultPageTitle;
    }

    if (!Object.values(RoutesKeys).includes(titleKey as RoutesKeys)) {
      return this.oopsPageTitle;
    }

    return titleKey;
  }

  /**
   * Updates title page based on current router url
   * @param {RouterStateSnapshot} routerState
   */
  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    this.titleService.setTitle(title);
  }
}
